module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-ide-1b1bc15d00b692f9585cb0484d23ac9e.png";